import React from 'react'
import styled from 'styled-components'
import ButtonShell from './ButtonShell'

const StyledButton = styled.span`
  background-color: ${props => props.theme.color.face.contrast};
  display: inline-block;
  border-radius: ${props => props.size === 'm' ? '20px' : '30px'};

  ${props => props.disabled && `
    opacity: .5;
  `};
  
  & > a, & > button {
    font-weight: ${props => props.theme.font.weight.s} !important;
    color: ${props => props.theme.color.text.light} !important;
    width: 100%;
    height: 100%;
    display: block;

    &:hover {
      color: ${props => props.theme.color.text.light};
      text-decoration: underline;
    }

    &:disabled {
      cursor: initial;
      text-decoration: none;
    }

    @media (min-width: 992px) {
      padding: ${props => props.size === 'm' ? '7px 25px' : '10px 30px'};
    }

    @media (max-width: 991px) {
      padding: 7px 25px;
    }
  }
`

const ButtonDefault = ({ disabled, isAnchor, isCustom, to, children, className, size = 'm', style = {} }) => (
  <StyledButton className={className} disabled={disabled} size={size} style={style}>
    {isCustom ? children : (
      <ButtonShell to={to} isAnchor={isAnchor}>
        {children}
      </ButtonShell>
    )}
  </StyledButton>
)

export default ButtonDefault